import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const toolTipStyles = css`
  .tool-tip {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px rgba(116, 119, 122, 0.06);
    background-color: ${themeGet('colors.main-text', 'black')};
    font-size: 0.8rem !important;
    line-height: normal;
    color: ${themeGet('colors.white', 'white')};
    --rt-opacity: 1;
  }
  .customTip {
    max-width: 200px;
    width: 100%;
    padding: 0.95rem;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px rgba(116, 119, 122, 0.06);
    background-color: ${themeGet('colors.main-text', 'black')};
    font-size: 0.9rem;
    line-height: normal;
    color: ${themeGet('colors.white', 'white')};
    z-index: 99999;
    --rt-opacity: 1;

    @media only screen and (min-width: 658px) {
      max-width: 225px;
    }

    @media only screen and (min-width: 1119px) {
      max-width: 300px;
      padding: 1.25rem;
    }

    sup {
      max-width: none;
      width: auto;
      padding: 0;
      box-shadow: none;
      border: none;
      background-color: transparent;
      position: relative;
      display: contents;
    }
  }
`;
